(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arccc-header-menu"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    document.querySelectorAll('.arccc-header-menu__details[open]').forEach(function(details) {
      if (!details.contains(event.target)) {
        details.removeAttribute('open');
      }
    });
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      document.querySelectorAll('.arccc-header-menu__details[open]').forEach(function(details) {
        details.removeAttribute('open');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arccc-photo-deck"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('arccc-photo-deck-v1')) {
    customElements.define('arccc-photo-deck-v1', class extends HTMLElement {
      connectedCallback() {
        this.boot = () => {
          if (!this.querySelector('[data-deck-end]') || this.ready) return;
          this.parserObserver?.disconnect();
          this.init();
        };
        this.boot();
        if (!this.ready) {
          this.parserObserver = new MutationObserver(this.boot);
          this.parserObserver.observe(this, { childList: true, subtree: true });
        }
      }

      init() {
        this.ready = true;
        this.epoch = (this.epoch || 0) + 1;
        this.events = new AbortController();
        const signal = this.events.signal;
        const on = (target, type, handler, options = {}) => target?.addEventListener(type, handler, { ...options, signal });
        this.stage = this.querySelector('[data-deck-stage]');
        this.cards = [...this.querySelectorAll('[data-deck-card]')];
        this.current = Math.min(this.current || 0, this.cards.length - 1);
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.reduced.matches;
        this.hovered = false;
        this.focusPaused = false;
        this.editorPaused = false;
        this.inView = false;
        this.busy = false;
        this.gesture = null;
        this.animations = new Set();
        this.clickUntil = 0;
        this.delay = Math.max(3, Number(this.dataset.interval) || 6) * 1000;
        this.progress = this.querySelector('[data-deck-progress]');
        this.pauseButton = this.querySelector('[data-deck-pause]');
        this.live = this.querySelector('[data-deck-announcement]');
        const label = this.querySelector('[data-deck-label]').content.textContent;
        const tabs = this.querySelector('[data-deck-tabs]');
        tabs.replaceChildren();
        this.tabs = this.cards.map((card, i) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'apd-tab';
          button.setAttribute('aria-label', label.replace('[number]', i + 1));
          button.append(document.createElement('span'));
          tabs.append(button);
          on(button, 'click', () => this.jump(i));
          return button;
        });
        this.setAttribute('data-ready', '');
        this.render();
        this.updatePause();
        on(this.querySelector('[data-deck-prev]'), 'click', () => this.turn(-1));
        on(this.querySelector('[data-deck-next]'), 'click', () => this.turn(1));
        on(this.pauseButton, 'click', () => {
          this.paused = !this.paused;
          if (!this.paused) this.focusPaused = false;
          this.updatePause();
          this.schedule();
        });
        on(this.stage, 'pointerdown', event => this.pointerDown(event));
        on(this.stage, 'pointermove', event => this.pointerMove(event), { passive: false });
        on(this.stage, 'pointerup', event => this.pointerEnd(event));
        on(this.stage, 'pointercancel', () => this.cancelGesture());
        on(this.stage, 'lostpointercapture', event => {
          if (event.target === this.stage && this.gesture) this.cancelGesture();
        });
        on(this.stage, 'dragstart', event => event.preventDefault());
        on(this, 'click', event => {
          if (this.stage.contains(event.target) && event.detail && Date.now() < this.clickUntil) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, { capture: true });
        on(this, 'pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.stop();
        });
        on(this, 'pointerleave', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = false;
          if (this.gesture?.kind === 'mouse' && this.gesture.axis !== 'x') this.cancelGesture();
          this.schedule();
        });
        on(this, 'focusin', event => {
          this.focusPaused = event.target.matches(':focus-visible');
          if (this.focusPaused) this.stop();
        });
        on(this, 'focusout', () => queueMicrotask(() => {
          if (!this.isConnected) return;
          this.focusPaused = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
          this.schedule();
        }));
        on(this, 'keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.target.matches('input,textarea,select')) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.turn(event.key === 'ArrowLeft' ? -1 : 1);
          }
        });
        on(document, 'visibilitychange', () => this.schedule());
        on(this.reduced, 'change', () => {
          if (this.reduced.matches) this.paused = true;
          this.updatePause();
          this.schedule();
        });
        on(document, 'shopify:block:select', event => {
          const index = this.cards.findIndex(card => card.dataset.blockId === event.detail?.blockId);
          if (index < 0) return;
          this.editorPaused = true;
          this.jump(index, false);
        });
        on(document, 'shopify:block:deselect', event => {
          if (!this.cards.some(card => card.dataset.blockId === event.detail?.blockId)) return;
          this.editorPaused = false;
          this.schedule();
        });
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.schedule();
        }, { threshold: 0.1 });
        this.observer.observe(this);
      }

      wrap(index) { return (index + this.cards.length) % this.cards.length; }

      layers(direction = 1) {
        this.cards.forEach(card => {
          card.dataset.layer = 'off';
          card.inert = true;
          card.setAttribute('aria-hidden', 'true');
        });
        for (let layer = Math.min(2, this.cards.length - 1); layer >= 0; layer--) {
          const card = this.cards[this.wrap(this.current + layer * direction)];
          card.dataset.layer = String(layer);
          if (layer === 0) {
            card.inert = false;
            card.removeAttribute('aria-hidden');
          }
        }
      }

      render() {
        this.layers();
        const card = this.cards[this.current];
        this.querySelector('[data-deck-title]').textContent = card.dataset.title;
        this.querySelector('[data-deck-caption]').textContent = card.dataset.caption;
        this.querySelector('[data-deck-current]').textContent = String(this.current + 1).padStart(2, '0');
        this.tabs.forEach((tab, index) => tab.setAttribute('aria-current', String(index === this.current)));
      }

      async turn(direction, announce = true) {
        if (this.busy || this.cards.length < 2) return;
        this.stop();
        this.busy = true;
        this.gesture = null;
        this.removeAttribute('data-dragging');
        this.layers(direction);
        const epoch = this.epoch;
        const front = this.cards[this.current];
        const next = this.cards[this.wrap(this.current + direction)];
        const duration = this.reduced.matches ? 1 : 430;
        const sign = direction > 0 ? -1 : 1;
        const distance = this.stage.clientWidth * 1.15;
        const animations = [
          front.animate([
            { transform: front.style.transform || 'none', opacity: 1 },
            { transform: `translateX(${sign * distance}px) rotate(${sign * 8}deg)`, opacity: 0 }
          ], { duration, easing: 'cubic-bezier(.22,.7,.2,1)', fill: 'forwards' }),
          next.animate([
            { transform: getComputedStyle(next).transform, opacity: .76 },
            { transform: 'none', opacity: 1 }
          ], { duration, easing: 'cubic-bezier(.22,.7,.2,1)', fill: 'forwards' })
        ];
        animations.forEach(animation => this.animations.add(animation));
        await Promise.all(animations.map(animation => animation.finished.catch(() => {})));
        if (!this.isConnected || epoch !== this.epoch) return;
        front.style.transform = '';
        this.current = this.wrap(this.current + direction);
        this.render();
        animations.forEach(animation => { animation.cancel(); this.animations.delete(animation); });
        this.busy = false;
        if (announce) this.live.textContent = this.tabs[this.current].getAttribute('aria-label');
        this.schedule();
      }

      jump(index, announce = true) {
        this.clearMotion();
        this.current = index;
        this.render();
        if (announce) this.live.textContent = this.tabs[index].getAttribute('aria-label');
        this.schedule();
      }

      pointerDown(event) {
        if (this.cards.length < 2 || this.busy || event.button !== 0) return;
        if (!event.isPrimary) { this.cancelGesture(); return; }
        this.stop();
        this.animations.forEach(animation => animation.cancel());
        this.animations.clear();
        this.clickUntil = 0;
        this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, dx: 0, axis: null, kind: event.pointerType };
      }

      pointerMove(event) {
        const gesture = this.gesture;
        if (!gesture || gesture.id !== event.pointerId) return;
        gesture.dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        if (!gesture.axis && Math.max(Math.abs(gesture.dx), Math.abs(dy)) >= 10) {
          gesture.axis = Math.abs(gesture.dx) > Math.abs(dy) * 1.2 ? 'x' : 'y';
          if (gesture.axis === 'x') {
            this.stage.setPointerCapture(event.pointerId);
            this.setAttribute('data-dragging', '');
          }
        }
        if (gesture.axis !== 'x') return;
        if (event.cancelable) event.preventDefault();
        this.clickUntil = Date.now() + 600;
        this.layers(gesture.dx < 0 ? 1 : -1);
        const rotation = this.reduced.matches ? 0 : Math.max(-8, Math.min(8, gesture.dx / 35));
        this.cards[this.current].style.transform = `translateX(${gesture.dx * .8}px) rotate(${rotation}deg)`;
      }

      pointerEnd(event) {
        const gesture = this.gesture;
        if (!gesture || gesture.id !== event.pointerId) return;
        this.gesture = null;
        this.removeAttribute('data-dragging');
        if (this.stage.hasPointerCapture(event.pointerId)) this.stage.releasePointerCapture(event.pointerId);
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        if (gesture.axis === 'x') this.clickUntil = Date.now() + 600;
        if (gesture.axis === 'x' && Math.abs(dx) >= Math.max(40, this.stage.clientWidth * .12) && Math.abs(dx) > Math.abs(dy) * 1.2) {
          this.turn(dx < 0 ? 1 : -1);
        } else {
          this.resetCard();
          this.schedule();
        }
      }

      resetCard() {
        const card = this.cards[this.current];
        const from = card.style.transform;
        card.style.transform = '';
        this.layers();
        if (from && !this.reduced.matches) {
          const animation = card.animate([{ transform: from }, { transform: 'none' }], { duration: 180, easing: 'ease-out' });
          this.animations.add(animation);
          animation.finished.catch(() => {}).then(() => this.animations.delete(animation));
        }
      }

      cancelGesture() {
        if (!this.gesture) return;
        this.gesture = null;
        this.removeAttribute('data-dragging');
        this.resetCard();
        this.schedule();
      }

      updatePause() {
        if (!this.pauseButton) return;
        this.pauseButton.setAttribute('aria-pressed', String(this.paused));
        this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
      }

      stop() {
        clearTimeout(this.timer);
        if (this.progress) this.progress.style.animation = 'none';
      }

      schedule() {
        this.stop();
        if (!this.isConnected || this.dataset.autoplay !== 'true' || this.cards.length < 2 || this.paused || this.hovered || this.focusPaused || this.editorPaused || this.busy || this.gesture || !this.inView || document.hidden) return;
        if (this.progress) {
          void this.progress.offsetWidth;
          this.progress.style.animation = `apd-timer ${this.delay}ms linear forwards`;
        }
        this.timer = setTimeout(() => this.turn(1, false), this.delay);
      }

      clearMotion() {
        this.epoch = (this.epoch || 0) + 1;
        this.stop();
        this.animations?.forEach(animation => animation.cancel());
        this.animations?.clear();
        this.cards?.forEach(card => { card.style.transform = ''; });
        this.gesture = null;
        this.busy = false;
        this.removeAttribute('data-dragging');
      }

      disconnectedCallback() {
        this.clearMotion();
        this.events?.abort();
        this.observer?.disconnect();
        this.parserObserver?.disconnect();
        this.ready = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
